import type { IZeosUser } from "../../../services/auth/IZeosUser";
import type { ICompanyClaims } from "../../../services/zeos-api/contracts/Account";

export interface IMenuItem {
  key: string;
  label: string;
  action: string;
}

const selectedCompanyStorageKey = "zeos.selectedCompanyId";

export const getSelectedCompanyStorageKey = (zeosUserId?: number | null) =>
  zeosUserId ? `${selectedCompanyStorageKey}.${zeosUserId}` : selectedCompanyStorageKey;

export const getPreferredDefaultCompanyId = (
  user: Pick<IZeosUser, "emailAddress"> | null | undefined,
  companies: ICompanyClaims[]
) => {
  if (user?.emailAddress?.toLowerCase() === "rcd@rewiregroup.net") {
    return companies.find((company) => company.companyName === "RCD")?.companyId.toString() ?? null;
  }

  return null;
};

export const getPropertyOwnerCompanyId = (
  companies: ICompanyClaims[],
  propertyId: string | null
) => {
  const parsedPropertyId = Number(propertyId);
  if (!propertyId || !Number.isFinite(parsedPropertyId)) {
    return null;
  }

  return (
    companies
      .find((company) =>
        company.properties?.some((property) => property.propertyId === parsedPropertyId)
      )
      ?.companyId.toString() ?? null
  );
};

// Order: URL company -> company owning the URL property -> preferred -> stored -> first.
export const selectDefaultCompanyMenuItem = (
  menuItems: IMenuItem[],
  defaultCompanyId: string | null,
  preferredCompanyId: string | null,
  storedCompanyId: string | null,
  propertyOwnerCompanyId: string | null = null
) => {
  const findCompanyMenuItem = (companyId: string | null) =>
    companyId ? menuItems.find((x) => x.key === companyId) : undefined;

  return (
    findCompanyMenuItem(defaultCompanyId) ??
    findCompanyMenuItem(propertyOwnerCompanyId) ??
    findCompanyMenuItem(preferredCompanyId) ??
    findCompanyMenuItem(storedCompanyId) ??
    menuItems[0]
  );
};
